<script>
    import { fade } from "svelte/transition";
    import { onDestroy } from "svelte";
    import { breatheState } from "./dataStore";

    let title = "Breathe with Time";
    let headerBgClass = "navbar-dark bg-success";
    const breatheStateSubs = breatheState.subscribe((val) => {
        switch (val) {
            case "initial":
                title = "Relax";
                headerBgClass = "navbar-light bg-warning";
                break;
            case "hold":
                title = "Hold";
                headerBgClass = "navbar-light bg-warning";
                break;
            case "exhale":
                title = "Exhale";
                headerBgClass = "navbar-dark bg-danger";
                break;
            case "inhale":
                title = "Inhale";
                headerBgClass = "navbar-dark bg-success";
                break;
            case "paused":
            default:
                title = "Breathe with Time";
                headerBgClass = "navbar-dark bg-success";
        }
    });
    onDestroy(breatheStateSubs);
</script>

<style>
</style>

<nav class="navbar {headerBgClass}">
    <a class="navbar-brand" href="/">{title}</a>
</nav>
